import { ISelectOption } from "core-integration/src/store";
import { getElementTypeFilterOptions } from "core-integration/src/store/elements/reducers";
import { FilterChip } from "plos/src/components/Chip";
import { PopoverSelect } from "plos/src/components/PopoverSelects";
import {
  Header,
  ListBoxItem,
  ListBoxSection,
  Selection,
} from "react-aria-components";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import styles from "../../../FilterPopovers/filterPopover.module.css";
import { PriceChangeElementFilter } from "../utils";
import elementFilterStyles from "./elementFilterPopover.module.css";

interface ElementFilterPopoverProps {
  hasEntry: boolean;
  value: PriceChangeElementFilter;
  onChange: (value: PriceChangeElementFilter) => void;
}

const ElementFilterPopover = ({
  hasEntry,
  value,
  onChange,
}: ElementFilterPopoverProps) => {
  const { t } = useTranslation("priceChanges");
  const elementTypeFilterOptions = useSelector(getElementTypeFilterOptions);

  const globalOptions: ISelectOption[] = [
    { value: "all", label: t("teamFilterPopover.allPlayers", "All players") },
  ];
  if (hasEntry) {
    globalOptions.push(
      {
        value: "myTeam",
        label: t("teamFilterPopover.myTeam", "My team"),
      },
      {
        value: "watchlist",
        label: t("filterPopovers.playerPopover.watchlist", "Watchlist", {
          ns: "common",
        }),
      },
    );
  }
  const elementOptions = [...globalOptions, ...elementTypeFilterOptions];

  const selectedOption =
    elementOptions.find((o) => o.value === value) ?? globalOptions[0];

  const handleChange = (keys: Selection) => {
    const key = Array.from(keys)[0];
    onChange((key as PriceChangeElementFilter) ?? "all");
  };

  return (
    <PopoverSelect
      popoverTrigger={
        <FilterChip
          label={t("teamFilterPopover.filterByPlayer", "Players")}
          selectedOption={[selectedOption]}
          isModified={value !== "all"}
        />
      }
      selectedKey={value}
      handleOnChange={handleChange}
    >
      {globalOptions.map(({ value: optionValue, label }) => (
        <ListBoxItem
          key={optionValue}
          id={optionValue}
          data-selected={optionValue === value}
          className={styles.popoverListItem}
          textValue={label}
        >
          {label}
        </ListBoxItem>
      ))}
      <ListBoxSection className={elementFilterStyles.listboxSection}>
        <Header className={elementFilterStyles.listboxSectionHeader}>
          {t("filterPopovers.playerPopover.position", "Position", {
            ns: "common",
          })}
        </Header>
        {elementTypeFilterOptions.map(({ value: optionValue, label }) => (
          <ListBoxItem
            key={optionValue}
            id={optionValue}
            data-selected={optionValue === value}
            className={styles.popoverListItem}
            textValue={label}
          >
            {label}
          </ListBoxItem>
        ))}
      </ListBoxSection>
    </PopoverSelect>
  );
};

export default ElementFilterPopover;
